
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component } from 'vue-property-decorator';
import WidgetMixins from '../../mixins/WidgetMixins';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { required, min } from 'vee-validate/dist/rules';
import { mixins } from 'vue-class-component';
import { IResetPassword } from '@/types/types';
import AuthLayout, { IPanelRow } from './components/AuthLayout.vue';

extend('required', {
  ...required,
  message: 'Field is required',
});
extend('min', {
  ...min,
  message: 'Field cannot have less than 6 characters',
});

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    AuthLayout,
  },
})
export default class SetUpAccounts extends mixins(WidgetMixins) {
  username: string = '';
  newPassword: string = '';
  confirmPassword: string = '';

  panelRows: IPanelRow[] = [
    {
      icon: 'badge',
      title: 'Pick your username',
      text: 'This is how you sign in to your dashboard.',
    },
    {
      icon: 'lock',
      title: 'Secure your account',
      text: 'Use at least 6 characters for your password.',
    },
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldState: any = {
    username: '',
    newPassword: false,
    confirmPassword: false,
  };

  completeAccount(): void {
    let payload: IResetPassword & { username: string } = {
      token: decodeURIComponent(this.$route.query.token as string),
      username: this.username,
      newPassword: this.newPassword,
      confirmPassword: this.confirmPassword,
    };

    this.$store.dispatch('users/completeAccountSetUp', payload);
  }

  changeState(state: string): void {
    this.$set(this.fieldState, state, !this.fieldState[state]);
  }
}
